import Cookies from 'js-cookie';
import { useIndexStore } from '~/store/index';
import type {
  Router,
  RouteLocationNormalizedLoaded,
  RouteLocationRaw,
} from 'vue-router';
import qs from 'qs';
import { COOKIE_NAME } from '~/frontend-shared/helper/login-util';

export default function () {
  return {
    hasLogin,
    gotoLogin,
    isLoginedToken,
  };
}

export const isLoginedToken = () => {
  // TODO 3619
  if (!Cookies.get(COOKIE_NAME.SALT) || !Cookies.get(COOKIE_NAME.SALT)?.length || Cookies.get(COOKIE_NAME.SALT) === 'undefined' || Cookies.get(COOKIE_NAME.SALT) === 'null') {
    return false;
  } else {
    return true;
  }
};

export function hasLogin(isStopRedirect = false, exLogin?: string) {
  const indexStore = useIndexStore();
  const route = useRoute();
  const router = useRouter();
  if (isLoginedToken()) {
    return true;
  }
  if (!isStopRedirect) {
    gotoLogin(router, route, indexStore.locale, route.query, undefined, exLogin);
  }
  return false;
}

export const gotoLogin = (
  router: Router,
  route: RouteLocationNormalizedLoaded,
  locale: string,
  others: object,
  otherQuery = {},
  exLogin?: string
) => {
  if (route.name === 'login-lang') {
    return;
  }
  const routeParam: RouteLocationRaw = {
    name: exLogin ? exLogin : 'login-lang',
    params: {
      lang: locale || 'en',
    },
    query: {
      goto: route.name as string,
      ...otherQuery,
    },
  };

  if (others) {
    (routeParam.query as any).others = JSON.stringify(others);
  }
  // router.push(routeParam);
  // navigateTo(routeParam);

  let urlString = `/${exLogin || 'login'}/${locale}?goto=${route.name as string}`;
  if (others) {
    urlString += `&others=${encodeURIComponent(JSON.stringify(others))}`;
  }
  navigateTo(urlString);
  
};

export const goLoginInSetup = (extraQuery?: object, others?: object, autoJump?: boolean,) => {
  const isLogined = isLoginedToken();
  if(isLogined || autoJump === false){
    return isLogined;
  }

  const indexStore = useIndexStore();
  const route = useRoute();
  // const router = useRouter();

  if (route.name === 'login-lang') {
    return;
  }
  // ??? router.push not working and navigateTo cause redirect loop; Maybe it's because of Nuxt
  const queryString = qs.stringify({
    goto: route.name as string,
    ...extraQuery,
    others: JSON.stringify(others),
  });
  window.location.href = `/login/${indexStore.normalizedLocaleWithCenterLine || 'en-US'}?${queryString}`;

}